import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

const BRIDGE_TIERS = ['hobby', 'personal', 'maker', 'commercial', 'farm']

/**
 * Check if the current user's subscription tier has access to Bridge features.
 * Bridge requires: Hobby, Maker, or Farm tier.
 * (personal/commercial are legacy aliases for hobby/maker)
 */
export function useBridgeAccess() {
  const authStore = useAuthStore()

  const hasBridgeAccess = computed(() => {
    const tier = authStore.subscriptionTier
    return BRIDGE_TIERS.includes(tier) || authStore.isAdmin
  })

  return { hasBridgeAccess }
}
